<template>
  <div class="app-container">
    <!-- pc -->
    <div v-if="isPc" class="pc">
      <div class="title">
        <div class="logo" >
          <img :src="imgUrl">
          <span class="name">{{appName}}</span>
        </div>
      </div>
      <div class="pc-container">
        <div class="code">
          <img class="hezi" :src="appQrCode" :alt="appName">
        </div>
        <p class="no-page">扫码下载APP</p>
        <div class="pc-download" hidden="hidden" v-if="pcDownLoad" @click="download('pc')">Windows PC版下载</div>
        <div class="pc-download" hidden="hidden" v-if="macDownLoad" @click="download('mac')">Apple Mac版下载</div>
      </div>
    </div>
    <!-- mobile -->
    <div v-else
         class="mobile">
      <div class="top">
        <!-- app图标 -->
        <div class="app-icon">
          <img class="img"
               :src="imgUrl"
               :alt="appName">
        </div>
        <!-- app名称 -->
        <p class="app-name">{{appName}}</p>
        <!-- 二维码 -->
         <div class="app-code">
          <img class="img"
               :src="appQrCode"
               :alt="appName">
        </div>
      </div>
      <div class="down" v-if="androidApkPath||iosApkPath">
        <el-button class="btn"
                   size="medium"
                   @click="downApp" :style="{'background':appType==='iOS'?'#F3A15F':'#54ABF1'}">{{appType==='iOS'?'iOS':'Android'}}下载</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'appDownload',
  data () {
    return {
      isPc: false,
      appName: '',
      imgUrl: '',
      androidApkPath: '',
      iosApkPath: '',
      appQrCode: '',
      appType: 'iOS',
      pcDownLoad: '',
      macDownLoad: '',
      tenantId: ''
    }
  },
  methods: {
    // pc and mobile判断
    isPcOrMobile () {
      let userAgentInfo = navigator.userAgent
      let flag = true
      if (/(iPhone|iPad|iPod|iOS)/i.test(userAgentInfo)) {
        // ios
        flag = false
        this.appType = 'iOS'
      } else if (/(Android)/i.test(userAgentInfo)) {
        // android
        this.appType = 'Android'
        flag = false
      }
      this.isPc = flag
    },
    // 初始数据获取
    getInitialData () {
      let params = {'domain': document.domain}
      this.$axios.get('/system-api/application/getSettingByDomain', {params}).then(res => {
        document.cookie = `tenantId=${res.data.data.id}`
        this.tenantId = res.data.data.id
        let link = document.querySelector("link[rel*='icon']")
        if (link) {
          link.type = 'image/x-icon'
          link.rel = 'shortcut icon'
          if (this.tenantId === '1696BDBF-CC00-09CF-B406-9198CC9854E2') {
            link.href = '../../static/favicon1.ico'
          } else {
            link.href = '../../static/favicon.ico'
          }
        }
        this.$axios.get('/mobile-api/design/no-auth/isUsedForPc').then(res => {
          let data = res.data
          this.appName = data.appName
          this.imgUrl = data.appIcon
          this.appQrCode = data.appQrCode
          this.androidApkPath = data.androidApkPath
          this.iosApkPath = data.iosApkPath
          this.pcDownLoad = data.pcUrl
          this.macDownLoad = data.macUrl
          document.title = this.appName || '下载'
        })
      })
    },
    downApp () {
      if (this.isWeixinBrowser()) {
        this.$message.warning('请用手机自带浏览器下载')
      } else {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          // ios
          location.href = `itms-services://?action=download-manifest&amp;url=${this.iosApkPath}`
        } else if (/(Android)/i.test(navigator.userAgent)) {
          // android
          location.href = this.androidApkPath
        }
      }
    },
    isWeixinBrowser () {
      let ua = navigator.userAgent.toLowerCase()
      return !!(/micromessenger/.test(ua))
    },
    // 缩放事件
    onResize () {
      window.onresize = _.debounce(e => {
        this.isPcOrMobile()
      }, 10)
    },
    download (val) {
      window.open(val === 'pc' ? this.pcDownLoad : this.macDownLoad)
    }
  },
  created () {
    document.title = '下载'
    this.isPcOrMobile()
    this.getInitialData()
  },
  mounted () {
    this.onResize()
  }
}
</script>
<style lang="scss" scoped>
.app-container {
  height: 100%;
}

.pc {
  height: 100%;
  position: relative;
  background: url("../assets/pc-down.png") no-repeat center center;
  background-size: 100% 100%;

  .title {
    height: 52px;
    border-bottom: 1px solid #ededed;

    .logo {
      width: 800px;
      margin: 0 auto;
      height: 52px;
      line-height: 52px;
      color: #22262E;
      font-size: 16px;

      img {
        width: 39px;
        height: 31px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 17px;
      }
    }
  }

  .pc-container {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .code {
      width: 166px;
      height: 166px;
      padding: 0;
      border: 1px solid #ededed;

      img {
        width: 164px;
        height: 164px;
        display: block;
      }
    }

    .no-page {
      color: #ACA9A9;
      margin: 44px 0 46px;
    }

    .pc-download {
      cursor: pointer;
      width: 166px;
      height: 30px;
      border: 1px solid #54ABF1;
      border-radius: 4px;
      color: #54ABF1;
      text-align: center;
      line-height: 30px;
      margin-bottom: 5px;
    }
  }
}

.mobile {
  height: 100%;
  text-align: center;
  padding-top: 14vw;

  .top {
    .app-name {
      font-size: 18px;
      font-weight: bold;
      color: rgba(34, 38, 46, 1);
      text-align: center;
      margin-bottom: 65px;
    }

    .app-icon {
      width: 14vw;
      height: 14vw;
      border-radius: 2px;
      margin: 0 auto 7vw;

      .img {
        width: 100%;
        height: 100%;
      }
    }

    .app-code {
      width: 43vw;
      height: 43vw;
      margin: 0 auto 17vw;

      .img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .down {
    .btn {
      padding-left: 50px;
      padding-right: 50px;
      color: #fff;
    }
  }

  .describe {
    width: 80%;
    color: #898989;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/system/appDesign/app-download.vue